
import axios from '../../helpers/axios';


export const updatedProductListLink = (id, updateProductListLink) => axios.patch(`/productListLink/update/${id}`, updateProductListLink)
